import React, { useEffect, useState } from "react";
import { Modal, Upload } from "antd";
import { FileImageOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { beforeUploadProductImg } from "./helper";

const CustomUpload = ({ onChange, list, value }) => {
  const [state, setState] = useState({
    previewTitle: "",
    fileList: list ?? [],
  });
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  // Хуулж дуустал товч дээр ачаалж буйг харуулж, давхар сонгохоос сэргийлнэ
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    onChange(state.fileList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.fileList]);

  useEffect(() => {
    if (typeof value === "string" && value.length > 0) {
      setState({
        previewTitle: "Барааны зураг",
        fileList: [{ url: value }],
      });
    }
  }, [value]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewVisible(true);
    setPreviewImage(file.url || file.preview);
    setState({
      fileList: [
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: file.url,
        },
      ],
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  const handleChange = (e) => {
    if (e?.fileList?.length === 0) {
      setState({ fileList: [], previewTitle: "" });
    }
    onChange(e?.fileList);
  };

  const { fileList, previewTitle } = state;
  const uploadButton = (
    <div style={{ fontSize: 18, color: "#4bbeda" }}>
      {uploading ? <LoadingOutlined /> : <FileImageOutlined />}
    </div>
  );
  return (
    <>
      <Upload
        listType="picture-card"
        fileList={fileList}
        beforeUpload={beforeUploadProductImg}
        onPreview={handlePreview}
        onChange={handleChange}
        disabled={uploading}
        customRequest={async ({ file }) => {
          setUploading(true);
          try {
            const formData = new FormData();
            formData.append("file", file);
            const res = await axios({
              method: "post",
              url: `${
                process.env.REACT_APP_STORAGE_URL
              }/upload/operator/product?fileName=product${Date.now()}&uid=${
                file.uid
              }`,
              data: formData,
            });
            const imagePath = res?.data?.result?.location ?? "";
            setState({
              fileList: [
                ...fileList,
                {
                  uid: file.uid,
                  name: file.name,
                  status: "done",
                  url: imagePath,
                },
              ],
            });
            return imagePath;
          } finally {
            setUploading(false);
          }
        }}
      >
        {fileList.length >= 1 ? null : uploadButton}
      </Upload>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt={previewTitle || "Зургийн урьдчилсан харагдац"} style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  );
};
export default CustomUpload;
